import * as Devices from './model';

export const PKeyMap = (data: Devices.PKey): Devices.PKey => {
  return {
    manufactureId: data.manufactureId,
    serialNumber: data.serialNumber,
  };
};

export const DeviceMap = (data: Devices.Device): Devices.Device => {
  return {
    ...PKeyMap(data),
    deviceName: data.deviceName,
    deviceType: data.deviceType,
    isActive: data.isActive,
    orderNumber: data.orderNumber,
    owner: data.owner,
    userWithReadRights: data.userWithReadRights,
    availability: data.availability,
    customerDeviceNo: data.customerDeviceNo,
    showOrderNumber: data.showOrderNumber,
  };
};

export const DeviceExtensionMap = (
  data: Devices.DeviceExtension
): Devices.DeviceExtension => {
  return {
    programNumber: data.programNumber,
    configurationNumber: data.configurationNumber,
    // longDeviceName: data.longDeviceName,
    typeNumber: data.typeNumber,
    consumptionType: data.consumptionType,
    manuallyAssignedOwnership: data.manuallyAssignedOwnership,
  };
};

export const TotalsMap = (data: Devices.Totals): Devices.TotalsByType => {
  return {
    totalConcentrators: data.totalConcentrators,
    totalGateways: data.totalGateways,
    totalMeters: data.totalMeters,
    totalRepeaters: data.totalRepeaters,
    totalValves: data.totalValves,
  };
};
